import { ColumnLayout } from "@mittwald/flow-components/dist/components/ColumnLayout";
import { Text } from "@mittwald/flow-components/dist/components/Text";
import type { FC } from "react";
import React from "react";
import { EmailAddressInput } from "../../../../pages/app/components/EmailAddressInput";
import FirstNameInput from "../../../../pages/app/components/FirstNameInput";
import LastNameInput from "../../../../pages/app/components/LastNameInput";
import { NewPasswordTextField } from "../../../../pages/authorization/register/components/NewPasswordTextField";
import { SalutationSelect } from "../../../../pages/app/components/SalutationSelect";

export const RegistrationStepContent: FC = () => {
  return (
    <>
      <Text i18n="registrationText" />
      <ColumnLayout medium={[1, 1]}>
        <SalutationSelect name="person.title" />
      </ColumnLayout>
      <ColumnLayout medium={[1, 1]}>
        <FirstNameInput name="person.firstName" required />
        <LastNameInput name="person.lastName" required />
      </ColumnLayout>
      <ColumnLayout medium={[1, 1]}>
        <EmailAddressInput rules={{ required: true }} />
      </ColumnLayout>
      <ColumnLayout medium={[1, 1]}>
        <NewPasswordTextField />
      </ColumnLayout>
    </>
  );
};
